import { reduxForm } from 'redux-form';
import { REPORT_HEALTH_INSURANCE_BONUS_FORM } from 'src/constants/FormNames';
import CsvModal from './CsvModal';

const validateLength = values => {
  const errors = {};
  if (values.serialNumber && !/^\d{3}$/.test(values.serialNumber)) {
    errors.serialNumber = 'は001〜999までの数字を入力してください。';
  }
  return errors;
};

const CsvModalForm = reduxForm({
  form: REPORT_HEALTH_INSURANCE_BONUS_FORM,
  validate: validateLength
})(CsvModal);

export default CsvModalForm;
